module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_01_american-village-52ee959dd04a7786d7bf5db1fcc3a1b1.jpg";